import { NgClass, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { ReactiveDialogContentComponent } from '@app/shared/components/dialog/reactive-dialog/base/reactive-dialog-content/reactive-dialog-content.component';
import { AbstractReactiveDialogComponent } from '../reactive-dialog/base/abstract-reactive-dialog-component';

interface NestedList {
  text: string;
  ordered?: boolean;
  listTypeClass?: 'upper-roman' | 'lower-alpha' | 'circle' | 'square';
  subtexts?: NestedList[];
}

@Component({
  selector:      'app-kundenportal-confirmation-info-dialog',
  templateUrl:   './kundenportal-confirmation-info-dialog.component.html',
  styleUrls:     ['./kundenportal-confirmation-info-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None // TODO find better way to style innerHtml links
  ,
  standalone: true,
  imports:    [
    ReactiveDialogContentComponent,
    NgFor,
    NgTemplateOutlet,
    MatButton,
    NgIf,
    NgClass
  ]
})
export class KundenportalConfirmationInfoDialogComponent extends AbstractReactiveDialogComponent implements OnInit {

  listText: NestedList[] = [
    {
      text: 'Um unseren Kunden, die noch keine Kundenportal-Nutzer sind, den Weg zu MEINE NV einfach und rasch zu ermöglichen, schicken wir einen persönlichen Identifizierungscode mit der Polizze mit.'
    },
    {
      text:     'Ein personalisiertes Infoblatt mit einem Identifizierungscode wird bei folgenden Polizzen beigelegt:',
      ordered:  false,
      subtexts: [
        {
          text: '1. VN ist mit dem Beitragszahler ident'
        },
        {
          text: 'nur für Polizzen im Außendienst'
        },
        {
          text:     'bei 6 Bearbeitungsarten in S/U und LV:',
          subtexts: [{text: 'Neuzugang mit Stornopolizze, Neuzugang mit Stornopolizze und Besitzwechsel, Konvertierung, Konvertierung mit Besitzwechsel, Neuzugang mit Stornopolizze Rente (nur LV)'}]
        }
      ]
    },
    {
      text: 'Wenn für eine Person (= 1.VN) an einem Tag mehrere Polizzen ausgestellt werden, so wird das Infoblatt jeder Polizze mit dem gleichen Identifizierungscode beigelegt.'
    },
    {
      text: 'Dieser Identifierungscode ist 30 Tage lang gültig.'
    },
    {
      text: '&nbsp;'
    },
    {
      text: '<b>Registrierung & Identifizierung:</b>'
    },
    {
      text: '&nbsp;'
    },
    {
      text:     'Bereits Kundenportal-Nutzer:',
      ordered:  true,
      subtexts: [
        {
          text: 'Webadresse: <a href="https://meine.nv.at" target="_blank" class="kundenportal-link">meine.nv.at</a>'
        },
        {
          text: 'Registrierung mittels E-Mail-Adresse und Passwort, Google Account oder schon bald ID Austria'
        },
        {
          text: 'Kunde erhält E-Mail mit einem Code zur Bestätigung'
        },
      ]
    },
    {
      text: 'Erstanmeldung:',
      ordered:  true,
      subtexts: [
        {
          text: 'Webadresse: <a href="https://meine.nv.at" target="_blank" class="kundenportal-link">meine.nv.at</a>'
        },
        {
          text: 'Button „Erstanmeldung zum Portal“ wählen'
        },
        {
          text: 'Kunde wählt die Registrierung mittels E-Mail-Adresse und Passwort, Google Account'
        },
        {
          text: 'Kunde erhält E-Mail mit Bestätigungslink'
        },
        {
          text: 'Nach der Anmeldung muss sich der Kunde mit einem Code identifizieren, um das Konto zu aktivieren und seine Bestandsdaten (Polizze, Schäden, …) einsehen zu können',
          subtexts:      [
            {
              text: 'a. Identifikation mittels Identifizierungscode Polizze oder Postbrief'
            },
            {
              text: 'b. Kunde fordert Code direkt über Portal an:',
              subtexts:      [
                {
                  text: 'Mobilnummer vorhanden: Kunde erhält TAN (Code) per SMS – wird der Code nicht zeitgerecht verwendet, erhält der Kunde einen neuen Code per Post <b>(bitte prüfen Sie die Mobilnummer des Kunden)</b>'
                },
                {
                  text: 'Keine Mobilnummer vorhanden: Kunde erhält Code per Post'
                },
                {
                  text: 'In kürze die Identifikation mittels ID Austria'
                }
              ]
            },
            {
              text: 'c. Kunde erhält Code über Marketingmaßnahme (sofern der Code nicht vom Kunden über das Portal angefordert wurde)'
            },
            {
              text: 'd. Kunde erhält Code über Polizze, wenn VN = BZ (sofern der Code nicht vom Kunden über das Portal angefordert wurde)'
            },
          ]
        },
        {
          text: 'Nachdem der Identifizierungscode erfasst wurde, steht dem Kunden das Portal vollumfassend zur Verfügung.'
        },
      ]
    },
    {
      text:     'Kundenportal als App nützen:',
      ordered:  true,
      subtexts: [
        {
          text: 'Über Handy/Tablet auf <a class="kundenportal-link" href="https://meine.nv.at" target="_blank">meine.nv.at</a> einsteigen'
        },
        {
          text:          'Nach mehrmaligem Aufruf der Seite erhält der Kunde am Handy/Tablet eine Meldung, ob er diese Seite zum Startbildschirm hinzufügen möchte (= als App nützen).',
          ordered:       false,
          listTypeClass: 'square',
          subtexts:      [
            {
              text: 'Android: Klick auf Menü-Symbol / Zum Startbildschirm hinzufügen'
            },
            {
              text: 'iOs: Klick auf den Teilen-Button / Zum Startbildschirm hinzufügen'
            }
          ]
        }
      ]
    }
  ];

  ngOnInit(): void {
    this.dialogInputData.title = 'Info Kundenportal';
  }

}
